import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import Header from "../ProcessSteps/Parts/Header";
import SubHeader from "../ProcessSteps/Parts/SubHeader";
import {Redirect} from "react-router";

class SpouseMandatory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step_count: 3,
            current_step: 1,
            redirect_url: null,
        }
    }

    render() {
        if (this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            return <Redirect push={true} to={this.state.redirect_url}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.error')}/>
                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('dear_customer')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>
                        <div className="row py-5">

                            <div className="col-12 d-flex justify-content-center text-center mt-4">
                                {/*<p className="heading--2">*/}
                                {/*    <span>MIELAS KLIENTE,</span>*/}
                                {/*</p>*/}
                            </div>
                            <div className="col-12">
                                Apgailestaujame, tačiau jūsų kreditingumo vertinimo duomenimis, finansavimo suteikti negalime.
                                Jeigu paskola yra skirta šeimos reikmėms, siūlome atlikti kreditingumo vertinimą kartu su sutuoktiniu.
                            </div>

                            <div className="col-12 text-center mt-4">
                                <button className="btn-primary btn" type="button"
                                        onClick={() => {
                                            this.setState({redirect_url: '/' + this.props.application_token + '/process/income_family'})
                                        }
                                        }>
                                    Noriu vertintis su sutuoktiniu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(SpouseMandatory);
